define(function (require, exports, module) {
    'use strict';

    module.name = 'module-metro-common';

    var base = require('base');
    var core = require('core');
    var tulip = require('module-metro-tulip');

    var deps = [
        core.name,
        tulip.name
    ];

    module.exports = base.createModule(module.name, deps)
        .service(require('./services/userPrivilegeService'))
        .factory(require('./services/metroUtils'))

        // date filters
        .service(require('./services/metDatesFormatter'))
        .service(require('./services/metroTransmitService'))
        .service(require('./services/metroUiHandler'))
        .provider(require('./services/metroContextService'))
        .provider(require('./services/metroToggleService'))
        .provider(require('./services/metroTaggingService'))
        .provider(require('./services/metToggleProvider'))
        .constant(require('./services/metroMeta'));
});



// WEBPACK FOOTER //
// ./scripts/main.js